module.exports = __webpack_public_path__ + "static/img/L06.d529b4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/L06.jpg
// module id = fCbF
// module chunks = 9